import Collection from '../utils/Collection'

class CartStore {
  constructor () {
    this.productCollection = Collection.create()
    this.contractorCollection = Collection.create()
    this.contractor = null
  }
}

export default new CartStore()
